// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1447":"app-fleet-view.module","1849":"semantic-css","2466":"public.module","3541":"loadboard.module","4119":"public-cards-application.module","4398":"driver-safety.module","5385":"device.module","9452":"team-driving.module"}[chunkId] || chunkId) + ".css";
};